import * as Yup from "yup";

export const singleEmailValidation = {
    email: Yup.string()
        .email((email) => `${email.value} isn't a valid email. `)
        .required("Required"),
};
